import { BeverageValuePrefix, DislikeValuePrefix, GoalValuePrefix, } from './formValuesModel';
import { parseHeightDisplay } from '../utils/heightUnits';
/** TextInput values arrive as strings; store profile numerics as JSON numbers. */
function toProfileNumber(value) {
    if (value === '' || value == null) {
        return undefined;
    }
    const n = typeof value === 'number' ? value : parseFloat(String(value));
    return Number.isFinite(n) ? n : undefined;
}
const PROFILE_NUMERIC_KEYS = [
    'existingWeight',
    'idealWeight',
    'eatOutCount',
];
export const extractProfileFromValues = (values, goalNames) => {
    const newProfile = {
        dislikes: [],
        beverages: [],
        goals: [],
    };
    Object.keys(values).forEach(key => {
        const value = values[key];
        // Handle dislikes
        if (key.startsWith(DislikeValuePrefix) && value) {
            const awFid = parseInt(key.match(/\d+/)[0], 10);
            newProfile.dislikes.push(awFid);
        }
        // Handle beverages
        else if (key.startsWith(BeverageValuePrefix) && value) {
            const awFid = parseInt(key.match(/\d+/)[0], 10);
            newProfile.beverages.push(awFid);
        }
        // Handle goals
        else if (key.startsWith(GoalValuePrefix) && value) {
            const goal = goalNames.find(g => key.includes(g));
            if (goal) {
                newProfile.goals.push(goal);
            }
        }
        // Descs
        else if (key.endsWith('Desc') && value) {
            newProfile[key] = value;
        }
        else if (PROFILE_NUMERIC_KEYS.includes(key)) {
            const n = toProfileNumber(value);
            if (n !== undefined) {
                newProfile[key] = n;
            }
        }
        // all the rest
        else if ([
            'birthDate',
            'gender',
            'phoneNumber',
            'timezone',
            'selfCook',
            'elseCook',
            'mealPrep',
        ].includes(key)) {
            newProfile[key] = value;
        }
    });
    const heightCm = parseHeightDisplay(String(values.heightDisplay ?? ''));
    if (heightCm != null) {
        newProfile.heightCm = heightCm;
    }
    return newProfile;
};
